<template>
  <div class="tiktok-analytics-public">
    <div class="loading-bar" v-if="loading"></div>
    <div class="loading-bar-hide" v-else></div>
    <div v-if="!campaign || !campaign.id"></div>
    <div class="tiktok-analytics-public-container" v-else>
      <TikTokAnalyticsPublicHeader class="mb-x2"></TikTokAnalyticsPublicHeader>
      <TikTokAnalyticsPublicFilter class="mb-x2"></TikTokAnalyticsPublicFilter>
      <TikTokAnalyticsPublicSummary class="mb-x2"></TikTokAnalyticsPublicSummary>
      <TikTokAnalyticsPublicChart></TikTokAnalyticsPublicChart>
    </div>
  </div>
</template>

<script lang="ts">
import moment from 'moment'
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import TikTokAnalyticsPublicChart from '@/client/features/tiktok_analytics_public/tiktok_analytics_public_chart'
import TikTokAnalyticsPublicFilter from '@/client/features/tiktok_analytics_public/tiktok_analytics_public_filter'
import TikTokAnalyticsPublicHeader from '@/client/features/tiktok_analytics_public/tiktok_analytics_public_header'
import TikTokAnalyticsPublicSummary from '@/client/features/tiktok_analytics_public/tiktok_analytics_public_summary'
import { useTikTokAnalyticsPublicStore } from '@/client/store/useTikTokAnalyticsPublicStore'
import { getAnalyticsDefaultPeriod } from '@/common/utils/analytics_period'

export default defineComponent({
  components: {
    TikTokAnalyticsPublicChart,
    TikTokAnalyticsPublicFilter,
    TikTokAnalyticsPublicHeader,
    TikTokAnalyticsPublicSummary
  },
  computed: {
    ...mapState(useTikTokAnalyticsPublicStore, {
      params: state => state.params,
      campaign: state => state.campaign,
      loading: state => state.loading
    })
  },
  async created() {
    const hash = this.$route.query.hash as string

    if (!hash) {
      return
    }

    const params = { hash }

    this.setParams(params)

    await this.fetchCampaign()
    await this.fetchPrizes()

    if (!this.campaign || !this.campaign.id) {
      return
    }

    const [startDatetime, endDatetime] = getAnalyticsDefaultPeriod(
      this.campaign.startDatetime,
      this.campaign.endDatetime
    )

    this.setParams({
      startDatetime: moment(startDatetime).format('YYYY-MM-DD'),
      endDatetime: moment(endDatetime).format('YYYY-MM-DD')
    })

    await this.fetchCampaignAnalytics()
  },
  methods: {
    ...mapActions(useTikTokAnalyticsPublicStore, [
      'fetchCampaignAnalytics',
      'fetchCampaign',
      'fetchPrizes',
      'setParams'
    ])
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.tiktok-analytics-public-container {
  max-width: $max-content-width;
  padding: $spacing-unit * 2;
  margin: 0 auto;
  background-color: #fff;
}
</style>
